import React from "react";
import { ProductData, TInventoryTable } from "../interface";
import PlaceHolderImage from "../../../../../assets/Images/placeholderimg.png";
import { currencySymbol, getUniqueObj, numberWithCommas } from "../../../../../constants/utils";
import constant from "../../../../../constants/constant";

export const inventoryColumns = (regionCode: number,gstType:number) => [
  {
    name: "Product Type",
    selector: (row: TInventoryTable) => !row?.last_row ? (row.product_type?.name ?? "") : "Total",
    sortable: true,
  },
  {
    name: "Cover Photo",
    cell: (row: TInventoryTable) => !row?.last_row ? (row?.images?.length>0 ? (
      <img
        src={row?.images?.[0] ?? PlaceHolderImage}
        alt="Cover"
        className="w-100 rounded object-contain"
      />
    ) : null) : '',
  },
  {
    name: "Brand",
    selector: (row: TInventoryTable) => !row?.last_row ?  (row.brand?.brand_name ?? "") : '',
  },
  {
    name: "Model Number",
    selector: (row: TInventoryTable) => !row?.last_row ?  (row.modal_number ?? "") : "",
  },
  {
    name: "Brand Color",
    selector: (row: TInventoryTable) => !row?.last_row ?  (row.brand_color_code ?? "") : "",
  },
  {
    name: "Glass Size/Power",
    selector: (row: TInventoryTable) => !row?.last_row ?  (row.glass_size ?? "" ) : "",
  },
  {
    name: `SRP (${currencySymbol(regionCode)})`,
    selector: (row: TInventoryTable) => !row?.last_row ? (row.product_srp ?? numberWithCommas(row?.product_srp)) : "",
  },
  {
    name: "With Case",
    selector: (row: TInventoryTable) => !row?.last_row ?  (row.product_with_case ? "Yes" : "No") : row?.additional_keys?.total_product_with_case
  },

  gstType === constant.GST_TYPE[0].value
  && {
    name: `GST (%)`,
    selector: (row: TInventoryTable) => !row?.last_row ?  row?.product_type?.gst_percentage : "",
  },
  {
    name: `Unit Cost Amount (${currencySymbol(regionCode)})`,
    selector: (row: TInventoryTable) => !row?.last_row ?  row.costAmount : "",
  },
  {
    name: `Discount(%)`,
    selector: (row: TInventoryTable) => !row?.last_row ?  row.discount_percentage : "",
  },
  {
    name: `Discount Amount`,
    selector: (row: TInventoryTable) => !row?.last_row ?  row.discount_amount : "",
  },
  {
    name: `Qty`,
    selector: (row: TInventoryTable) => !row?.last_row ?  row.product_qty : row?.additional_keys?.qty,
  },
  {
    name: `Amount`,
    selector: (row: TInventoryTable) => row?.additional_keys?.subtotal_amount?.toFixed(2) ?? "",
  },
  gstType === constant.GST_TYPE[0].value
  && {
      name: `Total GST`,
      selector: (row: TInventoryTable) =>
        row?.additional_keys?.gst_amount?.toFixed(2) ?? "",
    },
  {
    name: `Total Amount`,
    selector: (row: TInventoryTable) => gstType === constant.GST_TYPE[0].value ? row?.additional_keys?.grand_total_amount?.toFixed(2) : row?.additional_keys?.subtotal_amount?.toFixed(2),
  },


  {
    name: "Status",
    selector: (row: TInventoryTable) => !row?.last_row ? row?.is_Active : '',
  },
  {
    name: "Verification Status",
    selector: (row: TInventoryTable) => !row?.last_row ? row.verificationStatus : ''
  },
  {
    name: "Action",
    cell: (row: TInventoryTable) => !row?.last_row ?  row.action : '',
  },
].filter(Boolean);


// for contact lens
export const contactLensColumns = (regionCode: number,gstType:number) => [
  {
    name: "Product Type",
    selector: (row: ProductData, index: number) => row?.product_type?.name,
    sortable: true,
  },
  {
    name: "Brand",
    selector: (row: ProductData, index: number) => row?.brand?.brand_name,
  },
  {
    name: "Lens Color",
    selector: (row: ProductData | any, index: number) =>
      row.color?.color_name,
  },
  {
    name: `SRP (${currencySymbol(regionCode)})`,
    selector: (row: ProductData, index: number) =>
      numberWithCommas(row.product_srp),
  },

  gstType === constant.GST_TYPE[0].value && {
    name: `GST (%)`,
    selector: (row: TInventoryTable) => !row?.last_row ?  row?.product_type?.gst_percentage : "",
  },
  {
    name: `Unit Cost Amount (${currencySymbol(regionCode)})`,
    selector: (row: TInventoryTable) => !row?.last_row ?  row?.costAmount : "",
  },
  {
    name: `Discount(%)`,
    selector: (row: TInventoryTable) => !row?.last_row ?  row?.discount_percentage : "",
  },
  {
    name: `Discount Amount`,
    selector: (row: TInventoryTable) => !row?.last_row ?  row.discount_amount : "",
  },
  {
    name: `Qty`,
    selector: (row: TInventoryTable) => !row?.last_row ?  row.product_qty : row?.additional_keys?.qty,
  },
  {
    name: `Amount`,
    selector: (row: TInventoryTable) => row?.additional_keys?.subtotal_amount?.toFixed(2) ?? "",
  },
  gstType === constant.GST_TYPE[0].value && {
    name: `Total GST`,
    selector: (row: TInventoryTable) => row?.additional_keys?.gst_amount?.toFixed(2) ?? "",
  },
  {
    name: `Total Amount`,
    selector: (row: TInventoryTable) => gstType === constant.GST_TYPE[0].value  ? (row?.additional_keys?.grand_total_amount)?.toFixed(2) :  row?.additional_keys?.subtotal_amount?.toFixed(2),
  },


  {
    name: "Status",
    selector: (row: TInventoryTable) => !row?.last_row ? row?.is_Active : '',
  },
  {
    name: "Verification Status",
    selector: (row: TInventoryTable) => !row?.last_row ? row.verificationStatus : ''
  },
  {
    name: "Action",
    cell: (row: TInventoryTable) => !row?.last_row ?  row.action : '',
  },
];
